import { ChevronLeft } from '@untitled-ui/icons-react';
import classNames from 'classnames';
import React from 'react';

import { Button } from '@myhealth-raccoon/components';

export type BackButtonProps = {
    label: string | undefined;
    onClick?(): void;
    fullWidth?: boolean;
};

export const BackButton = ({ label, onClick, fullWidth, ...props }: BackButtonProps) => (
    <>
        <div className="ml-[-10px] block flex-1 pt-1 md:hidden" onClick={onClick}>
            <ChevronLeft className="h-10 w-10" />
        </div>
        <Button
            onClick={onClick}
            className={classNames(fullWidth && 'flex-1', 'hidden text-center md:block')}
            color="gray"
            {...props}
        >
            <span>{label}</span>
        </Button>
    </>
);
